export default "__VITE_ASSET__03rIRW$s__"